function addedToCart(addedItem) {
    //request cart information from /cart.js endpoint
    return new Promise(resolve => {
        fetch(`${window.location.origin}/cart.js`)
            .then((resCart) => resCart.json())
            .then((data) => {
                let eventProperties = {
                    total_price: data.total_price / 100,
                    $value: data.total_price / 100,
                    total_discount: data.total_discount,
                    original_total_price: data.original_total_price / 100,
                    items: data.items
                }
                var item = item || {};
                //item is set in our VP snippet on Shopify product pages
                //if item is set (i.e code is executing on a product page), then use that item object
                if (Object.keys(item).length !== 0) {
                    eventProperties = Object.assign(eventProperties, item)
                }
                //if code executing on a page without the VP snippet (i.e executing on Collections page)
                //then build formattedItem object
                else {
                    var formattedItem = {
                        "Name": addedItem.title,
                        "ProductID": addedItem.id,
                        "ImageURL": addedItem.image,
                        "URL": `${window.location.origin}${addedItem.url}`,
                        "Brand": addedItem.vendor,
                        "Price": addedItem.price / 100
                    }
                    eventProperties = Object.assign(eventProperties, formattedItem)
                }
                
                //grab variant level data from the JSON of the product page
                fetch(`${window.location.origin}${addedItem.url.split("?")[0]}.json`)
                    .then((resVariant) => resVariant.json())
                    .then((data) => {
                        eventProperties["variant_id"] = addedItem.id
                        let variantInfo = {}
                        for (variantIdx in data.product.variants) {
                            if (data.product.variants[variantIdx].id == addedItem.id) {
                                variantInfo = data.product.variants[variantIdx]
                            }
                        }
                        eventProperties["variant"] = variantInfo
                        
                        let cartRequests = []
                        eventProperties.items.forEach(
                            (item) => {
                                cartRequests.push(getItemInventory(item))
                            }
                        )
                        Promise.all(cartRequests).then((cartData) => {
                            let totalInventory = 0
                            cartData.forEach(
                                (item) => {
                                    totalInventory += item.inventory_quantity
                                }
                            )
                            eventProperties.items = cartData
                            eventProperties.totalInventory = totalInventory
                            klaviyo.track("Added to Cart", eventProperties)
                        })

                    })
            })
    })
}

function getItemInventory(item) {
    // Get inventory for a given item
    return new Promise(resolve => {
        var handle = item.handle;
        fetch(`${window.location.origin}/products/${handle}.json`)
            .then((resVariant) => resVariant.json())
            .then((data) => {
                item.inventory_quantity = data.product.variants[0].inventory_quantity
                resolve(item)
            })
    })
}


//2 different event listeners on the page depending on language (fetch or jquery/ajax)
(function (ns, fetch) {
    ns.fetch = function () {
        let url = ""
        const response = fetch.apply(this, arguments);
        response
            .then((resATC) => {
                url = resATC.url
                let ret = ""
                try {
                    ret = resATC.clone().json()
                } catch (e) { }
                return ret
            })
            .then((data) => {
                if (url.includes("/cart/add")) {
                    addedToCart(data)
                }
            }).catch((error) => {});
        return response
    }
}(window, window.fetch))